var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditListing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.20703 2.79302H4.20703C2.55018 2.79302 1.20703 4.13617 1.20703 5.79302V15.7931C1.20703 17.45 2.55018 18.7931 4.20703 18.7931H14.207C15.8639 18.7931 17.207 17.45 17.207 15.7931L17.207 10.7931M6.20703 13.793L9.84535 13.0599C10.0385 13.021 10.2158 12.9259 10.3551 12.7865L18.4999 4.63734C18.8904 4.24663 18.8901 3.61331 18.4993 3.22292L16.7739 1.49952C16.3833 1.1093 15.7502 1.10957 15.3599 1.50012L7.21433 9.65016C7.07532 9.78925 6.9804 9.96624 6.94145 10.159L6.20703 13.793Z",
    stroke: "#20639B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditListing);
export default __webpack_public_path__ + "static/media/edit-listing.732e6bcb0636e668649e2d4ce10f749f.svg";
export { ForwardRef as ReactComponent };